import * as React from "react";
import * as DTO from "../../../../../../../interfaces";

import { PromptsByCategory } from "./components/PromptsByCategory";

interface OwnProps {
  categories: DTO.Category[];
  coachId: string;
  campaignPrompts: DTO.SelectedPrompts;

  onAddPromptHandler: (prompt: DTO.Prompt) => void;
  onRemovePromptHandler: (prompt: DTO.Prompt) => void;
}

type Props = OwnProps;

const PromptList: React.FC<Props> = ({
  categories,
  coachId,
  campaignPrompts = {},
  onAddPromptHandler,
  onRemovePromptHandler,
}) => {
  const uncategorized: DTO.Category = {
    categoryId: "uncategorized",
    name: "Uncategorized",
  };
  return (
    <div className="promptListContainer">
      <PromptsByCategory
        coachId={coachId}
        key={"uncategorized"}
        category={uncategorized}
        campaignPrompts={campaignPrompts}
        onAddPrompt={onAddPromptHandler}
        onRemovePrompt={onRemovePromptHandler}
      />

      {categories.map(category => {
        return (
          <PromptsByCategory
            coachId={coachId}
            key={category.categoryId}
            category={category}
            campaignPrompts={campaignPrompts}
            onAddPrompt={onAddPromptHandler}
            onRemovePrompt={onRemovePromptHandler}
          />
        );
      })}
    </div>
  );
};

export default PromptList;
